export interface ShipModel
{
    speedRanges: {
        min: number;
        max: number;
    }[];
    shipProfile: {
        wind_profile: {
            resistances: {
                direction: number;
                value: number;
            }[];
            wind_speed: number;
        }[];
        wave_profile: {
            resistances: {
                direction: number;
                value: number;
            }[];
            wave_height: number;
        }[];
        speed_remainings: {
            resistance: string; // Why strings all of a sudden?!
            value: string; // Why strings all of a sudden?!
        }[];
        fuel_profile: {
            fuel: number;
            rpm: number;
            speed: number;
        }[];
        other_fuel_consumption: number;
        ship_measurements: {
            lpp: number;
            beam: number;
            draft: number;
            air_draft: number;
            cb: number; // block coefficient
        },
        safety_contour: {
            aft_margin: number;
            air_margin: number;
            draft_margin: number;
            forward_margin: number;
            portside_margin: number;
            starboard_margin: number;
        },
        ship_dynamics: {
            max_rot: number;
        },
        ship_type: number;
    }
}

// Ship profile for the Gudrun class, received from the analytics team on 06/12/2019
export const DefaultShipModel: ShipModel = {
    speedRanges: [
        {
            min: 5,
            max: 16
        }
    ],
    shipProfile: {
        wind_profile: [
            {
                resistances: [
                    {
                        direction: 0,
                        value: 0
                    },
                    {
                        direction: 45,
                        value: 0
                    },
                    {
                        direction: 90,
                        value: 0
                    },
                    {
                        direction: 135,
                        value: 0
                    },
                    {
                        direction: 180,
                        value: 0
                    }
                ],
                wind_speed: 0.0
            },
            {
                resistances: [
                    {
                        direction: 0,
                        value: 3
                    },
                    {
                        direction: 45,
                        value: 3
                    },
                    {
                        direction: 90,
                        value: 2
                    },
                    {
                        direction: 135,
                        value: -1
                    },
                    {
                        direction: 180,
                        value: -2
                    }
                ],
                wind_speed: 5.0
            },
            {
                resistances: [
                    {
                        direction: 0,
                        value: 7
                    },
                    {
                        direction: 45,
                        value: 8
                    },
                    {
                        direction: 90,
                        value: 3
                    },
                    {
                        direction: 135,
                        value: -2
                    },
                    {
                        direction: 180,
                        value: -3
                    }
                ],
                wind_speed: 10.0
            },
            {
                resistances: [
                    {
                        direction: 0,
                        value: 11
                    },
                    {
                        direction: 45,
                        value: 13
                    },
                    {
                        direction: 90,
                        value: 3
                    },
                    {
                        direction: 135,
                        value: -3
                    },
                    {
                        direction: 180,
                        value: -3
                    }
                ],
                wind_speed: 15.0
            },
            {
                resistances: [
                    {
                        direction: 0,
                        value: 14
                    },
                    {
                        direction: 45,
                        value: 19
                    },
                    {
                        direction: 90,
                        value: 3
                    },
                    {
                        direction: 135,
                        value: -3
                    },
                    {
                        direction: 180,
                        value: -4
                    }
                ],
                wind_speed: 20.0
            },
            {
                resistances: [
                    {
                        direction: 0,
                        value: 23
                    },
                    {
                        direction: 45,
                        value: 26
                    },
                    {
                        direction: 90,
                        value: 3
                    },
                    {
                        direction: 135,
                        value: -3
                    },
                    {
                        direction: 180,
                        value: -6
                    }
                ],
                wind_speed: 25.0
            }
        ],
        wave_profile: [
            {
                resistances: [
                    {
                        direction: 0,
                        value: 0
                    },
                    {
                        direction: 45,
                        value: 0
                    },
                    {
                        direction: 90,
                        value: 0
                    },
                    {
                        direction: 135,
                        value: 0
                    },
                    {
                        direction: 180,
                        value: 0
                    }
                ],
                wave_height: 0.0
            },
            {
                resistances: [
                    {
                        direction: 0,
                        value: 3
                    },
                    {
                        direction: 45,
                        value: 4
                    },
                    {
                        direction: 90,
                        value: 1
                    },
                    {
                        direction: 135,
                        value: 2
                    },
                    {
                        direction: 180,
                        value: 0
                    }
                ],
                wave_height: 2.0
            },
            {
                resistances: [
                    {
                        direction: 0,
                        value: 12
                    },
                    {
                        direction: 45,
                        value: 16
                    },
                    {
                        direction: 90,
                        value: 4
                    },
                    {
                        direction: 135,
                        value: 7
                    },
                    {
                        direction: 180,
                        value: 1
                    }
                ],
                wave_height: 4.0
            },
            {
                resistances: [
                    {
                        direction: 0,
                        value: 26
                    },
                    {
                        direction: 45,
                        value: 35
                    },
                    {
                        direction: 90,
                        value: 9
                    },
                    {
                        direction: 135,
                        value: 15
                    },
                    {
                        direction: 180,
                        value: 13
                    }
                ],
                wave_height: 6.0
            },
            {
                resistances: [
                    {
                        direction: 0,
                        value: 46
                    },
                    {
                        direction: 45,
                        value: 58
                    },
                    {
                        direction: 90,
                        value: 16
                    },
                    {
                        direction: 135,
                        value: 26
                    },
                    {
                        direction: 180,
                        value: 5
                    }
                ],
                wave_height: 8.0
            },
            {
                resistances: [
                    {
                        direction: 0,
                        value: 68
                    },
                    {
                        direction: 45,
                        value: 80
                    },
                    {
                        direction: 90,
                        value: 24
                    },
                    {
                        direction: 135,
                        value: 40
                    },
                    {
                        direction: 180,
                        value: 0
                    }
                ],
                wave_height: 10.0
            }
        ],
        speed_remainings: [
            {
                resistance: "0",
                value: "100"
            },
            {
                resistance: "48",
                value: "80"
            },
            {
                resistance: "77",
                value: "60"
            },
            {
                resistance: "100",
                value: "40"
            },
            {
                resistance: "116",
                value: "20"
            },
            {
                resistance: "123",
                value: "0"
            }
        ],
        fuel_profile: [
            {
                fuel: 0.33,
                rpm: 28.594,
                speed: 2.0
            },
            {
                fuel: 0.6,
                rpm: 36.027,
                speed: 4.0
            },
            {
                fuel: 1.11,
                rpm: 44.824,
                speed: 6.0
            },
            {
                fuel: 2.4,
                rpm: 58.369,
                speed: 8.0
            },
            {
                fuel: 4.67,
                rpm: 72.944,
                speed: 10.0
            },
            {
                fuel: 8.6,
                rpm: 89.862,
                speed: 12.0
            }
        ],
        other_fuel_consumption: 1,
        ship_measurements: {
            lpp: 351.08099999999996,
            beam: 42.8,
            draft: 12.2,
            air_draft: 12,
            cb: 0.6 // Placeholder - not the actual value
        },
        safety_contour: {
            aft_margin: 3,
            air_margin: 1,
            draft_margin: 4,
            forward_margin: 3,
            portside_margin: 10,
            starboard_margin: 10
        },
        ship_dynamics: {
            max_rot: 35
        },
        ship_type: 1 // Container vessel
    }
};